<template>
    <div>
        <x-select
            :name="`relationsSourceDataPropertySelection${_uid}`"
            :text="$t('relations.attributeSource')"
            :options="orderedSourcePropertiesChoices"
            :showDefaultOption="true"
            :simpleMode="true"
            :value="selectedSourcePropertiesChoice"
            @changed="$_onSourcePropertySelected($event)"
        />
        <x-select
            :name="`relationsTargetDataPropertySelection${_uid}`"
            :text="$t('relations.attributeTarget')"
            :options="orderedTargetPropertiesChoices"
            :showDefaultOption="true"
            :simpleMode="true"
            :value="selectedTargetPropertiesChoice"
            @changed="$_onDestinationPropertySelected($event)"
        />
        <x-checkbox
            v-if="localRelationItem.dataType === RELATION_FIELD_DATA_TYPES.string"
            :name="`relationFieldCaseSensitive${_uid}`"
            :text="$t('relations.caseSensitive')"
            v-model="localRelationItem.caseSensitive"
        />
    </div>
</template>

<script>
    import { RELATION_FIELD_DATA_TYPES } from '../../../constants';
    import XCheckbox from '../../BaseComponents/x-checkbox.vue';
    import XSelect from '../../BaseComponents/x-select.vue';

    const sortRelationsProperties = (a, b) => {
        if (a.text < b.text) {
            return -1;
        }
        if (a.text > b.text) {
            return 1;
        }
        return 0;
    };

    export default {
        props: {
            relationItem: { type: Object, required: true },
            sourcePropertiesChoices: { type: Array, required: true },
            targetPropertiesChoices: { type: Array, required: true },
        },
        components: {
            'x-checkbox': XCheckbox,
            'x-select': XSelect,
        },
        data() {
            return {
                RELATION_FIELD_DATA_TYPES: RELATION_FIELD_DATA_TYPES,
                localRelationItem: null
            };
        },
        watch: {
            relationItem: {
                handler: function() {
                    this.localRelationItem = { ...this.relationItem };
                },
                immediate: true
            },
            localRelationItem: {
                handler: function(newVal) {
                    if (JSON.stringify(this.relationItem) !== JSON.stringify(newVal)) {
                        this.$emit('update', newVal);
                    }
                },
                deep: true
            }
        },
        computed: {
            orderedTargetPropertiesChoices() {
                return [...this.targetPropertiesChoices].sort(sortRelationsProperties);
            },
            orderedSourcePropertiesChoices() {
                return [...this.sourcePropertiesChoices].sort(sortRelationsProperties);
            },
            selectedTargetPropertiesChoice() {
                return this.targetPropertiesChoices.find(({ value }) => value.name === this.relationItem.destinationFieldName)?.value;
            },
            selectedSourcePropertiesChoice() {
                return this.sourcePropertiesChoices.find(({ value }) => value.name === this.relationItem.sourceFieldName)?.value;
            }
        },
        methods: {
            $_onDestinationPropertySelected(item) {
                this.$set(this.localRelationItem, 'destinationFieldName', item ? item.name : null);
                this.$set(this.localRelationItem, 'dataType', item ? item.type : null);
            },
            $_onSourcePropertySelected(item) {
                this.$set(this.localRelationItem, 'sourceFieldName', item ? item.name : null);
            }
        }
    };
</script>
